/** Tokens de layout — painéis tenant (mobile-first). */

export const LAYOUT_SHELL =
  'min-h-dvh bg-gray-950 text-white flex';

/** Padding horizontal da página respeitando o notch em paisagem (iPhone).
 *  `max()` garante o padding visual mínimo quando não há safe area. */
export const LAYOUT_SAFE_X =
  'pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))] sm:pl-[max(1.5rem,env(safe-area-inset-left))] sm:pr-[max(1.5rem,env(safe-area-inset-right))]';

export const LAYOUT_HEADER =
  'sticky top-0 z-30 border-b border-white/[0.06] bg-gray-950/90 backdrop-blur-md supports-[backdrop-filter]:bg-gray-950/80';

/** Header full-bleed — alinhado às bordas da página (sem max-w). */
export const LAYOUT_HEADER_INNER =
  'grid h-14 w-full grid-cols-[1fr_auto_1fr] items-center gap-3 sm:h-16 ' + LAYOUT_SAFE_X;

export const LAYOUT_MAIN =
  'relative z-10 mx-auto w-full flex-1 pb-8 pt-6 sm:pb-12 sm:pt-10 lg:pt-12 ' + LAYOUT_SAFE_X;

export const LAYOUT_FOOTER =
  'relative z-10 border-t border-white/[0.04] py-5 sm:py-6';

/** Grade 2×2 no mobile — exclusiva do hub TenantHome (`ModuleGrid`). */
export const LAYOUT_GRID_TENANT_MODULES =
  'grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-3';

export const LAYOUT_BTN_GHOST =
  'inline-flex min-h-10 items-center gap-1.5 rounded-xl bg-white/[0.05] px-3 py-2 text-xs font-semibold text-slate-400 transition-all duration-300 hover:bg-white/10 hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20 active:scale-95';

export const LAYOUT_BTN_BACK = LAYOUT_BTN_GHOST;

export const LAYOUT_ALERT_ERROR =
  'rounded-2xl border border-red-500/20 bg-red-500/10 px-4 py-3 text-sm text-red-400';

export const LAYOUT_ALERT_SUCCESS =
  'flex items-center gap-3 rounded-xl border border-emerald-500/20 bg-emerald-500/10 px-4 py-3 text-sm text-emerald-400';

export const LAYOUT_ALERT_WARNING =
  'flex items-center gap-3 rounded-xl border border-yellow-500/20 bg-yellow-500/10 px-4 py-3 text-sm text-yellow-400';

export type LayoutWidth = 'default' | 'narrow' | 'wide';

export const LAYOUT_MAX_WIDTH: Record<LayoutWidth, string> = {
  default: 'max-w-5xl',
  narrow:  'max-w-3xl',
  wide:    'max-w-4xl',
};
